<div class="flex flex-column gap-1">
  <div class="flex gap-1 justify-content-between">
    <div class="flex gap-1 px-2">
      <mat-icon *ngIf="icon" class="text-700 material-symbols-outlined">{{icon}}</mat-icon>
      <div class="text-sm text-700 ">{{title}}</div>
    </div>
    <div class="px-1 text-sm">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
  <mat-divider class="text-primary" style="color: blue !important;"></mat-divider>
  <div [class]="'flex flex-column gap-1 ' + (borderless === false ? 'border-round border-1 surface-border bg-white p-2' : 'py-1 px-2')">
    <ng-content></ng-content>
  </div>
</div>
